import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsCollectorsAddRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-collectors-add',
	path: '/secure/AddCollector([!%]?[\\w]*).jspa',
	query: ['projectKey'],
};
